module.exports = __webpack_public_path__ + "img/intro1_ko.f3e8f948.jpg";